import React from 'react';
import { motion } from 'framer-motion';
import { Shield, ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-white" data-id="element-65">
      {/* Soft Background Gradients */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-blue-50/50 rounded-full blur-3xl pointer-events-none" data-id="element-66"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-67">
        <div className="text-center max-w-4xl mx-auto" data-id="element-68">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-50 border border-slate-200 text-slate-700 font-medium text-sm mb-8" data-id="element-69">
            <Shield size={16} data-id="element-70" />
            <span data-id="element-71">Надійний правовий захист по всій Україні</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-slate-900 tracking-tight text-balance mb-8 leading-[1.1]" data-id="element-72">
            Захищаємо ваші права у найскладніших ситуаціях
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl text-slate-500 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-73">
            Фахова правова допомога у військових, адміністративних, кримінальних
            та цивільних справах. Реальний супровід від аналізу до результату.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-74">
            <a href="#contact" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 rounded-full text-base font-semibold transition-all shadow-lg shadow-slate-900/10 hover:shadow-xl hover:-translate-y-0.5" data-id="element-75">
              Отримати допомогу
              <ArrowRight size={20} data-id="element-76" />
            </a>
            <a href="#services" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 px-8 py-4 rounded-full text-base font-semibold transition-all shadow-sm hover:shadow" data-id="element-77">
              Наші послуги
            </a>
          </motion.div>

          {/* Trust Indicators */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm font-medium text-slate-600" data-id="element-78">
            <div className="flex items-center gap-2" data-id="element-79">
              <CheckCircle2 size={18} className="text-blue-500" data-id="element-80" />
              <span data-id="element-81">Працюємо онлайн та офлайн</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-82">
              <CheckCircle2 size={18} className="text-blue-500" data-id="element-83" />
              <span data-id="element-84">Аналіз документів</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-85">
              <CheckCircle2 size={18} className="text-blue-500" data-id="element-86" />
              <span data-id="element-87">Представництво в суді</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}